import React from "react";

export function Marquee({ items, className = "", speed = 40 }) {
  return (
    <div className={`overflow-hidden no-scrollbar ${className}`}>
      <div className="marquee-track flex whitespace-nowrap" style={{ animationDuration: `${speed}s` }}>
        {[...items, ...items].map((it, i) => (
          <div key={i} className="flex items-center gap-16 pr-16 shrink-0">
            <span className="font-display text-3xl md:text-5xl text-white/70 italic">{it}</span>
            <span className="text-emerald-400/70 text-2xl">✦</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export function PartnerMarquee({ items }) {
  return (
    <div className="overflow-hidden no-scrollbar">
      <div className="marquee-track flex whitespace-nowrap" style={{ animationDuration: `50s` }}>
        {[...items, ...items].map((it, i) => (
          <div key={i} className="flex items-center gap-10 pr-10 shrink-0">
            <span className="text-sm tracking-[0.2em] uppercase text-slate-500">{it}</span>
            <span className="w-1 h-1 rounded-full bg-slate-300" />
          </div>
        ))}
      </div>
    </div>
  );
}
